import { useFormikContext } from "formik";
import React, { FC } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { WizardSummaryLayout } from '../../wizard/wizard-summary-layout';

interface SummaryStepProps {
    onBack: (e: any) => void;
}

const SummaryStep: FC<SummaryStepProps> = ({ onBack }) => {
    const { values } = useFormikContext<any>();
    const { translate } = useLocale();
    
    return <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.confirm)}>
        <div>
            <div className="flex flex-col flex-1">
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.name)}: <span className="text-sm text-black">{values.name}</span></h4>
                {
                    values.description ?
                        <h4 className="p-1 text-xs text-gray-600">
                            {translate.byKey(TranslationKeys.description)}{`:`} <span className="text-sm text-black">{values.description}</span>
                        </h4> : null
                }
            </div>

            {/* Only show Access Groups section if there are selected access groups */}
            {values.accessGroupRows && values.accessGroupRows.length > 0 && (
                <div className="flex flex-row flex-1">
                    <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.accessGroups)}:</h4>
                    <ul className="flex flex-col">
                        {values.accessGroupRows.map((accessGroup: any, index: number) => {
                            return <li key={index}>
                                <span className="text-sm text-black">{accessGroup.name}</span>
                            </li>
                        })}
                    </ul>
                </div>)}
            {/* Only show Floor Groups section if there are selected floor groups */}
            {values.floorGroupRows && values.floorGroupRows.length > 0 && (
                <div className="flex flex-row flex-1">
                    <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.floorGroups)}:</h4>
                    <ul className="flex flex-col">
                        {values.floorGroupRows.map((floorGroup: any, index: number) => {
                            return <li key={index}>
                                <span className="text-sm text-black">{floorGroup.name}</span>
                            </li>
                        })}
                    </ul>
                </div>)}

            {/* Only show Oss Groups section if there are selected oss groups */}
            {values.ossGroupRows && values.ossGroupRows.length > 0 && (
                <div className="flex flex-row flex-1">
                    <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.ossGroups)}:</h4>
                    <ul className="flex flex-col">
                        {values.ossGroupRows.map((ossGroup: any, index: number) => {
                            return <li key={index}>
                                <span className="text-sm text-black">{ossGroup.name}</span>
                            </li>
                        })}
                    </ul>
                </div>)}
        </div>
    </WizardSummaryLayout>
}

export default SummaryStep;
